import React from "react";
import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";
import { STANDARD_CHARTERED_URL } from "@util/constant";

/**
 * Component to render Standard Chartered section on Partners page
 */
const StandardCharteredSection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150"
      data-testid="standard-chartered-section-component"
    >
      <AccordionV2
        testId="standard-chartered"
        className="border-l border-r py-4"
        headerChildren={
          <EventsAwardsAccordionHeader title="Standard Chartered" />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mt-4 border-t border-gray-175 px-6 py-4 pt-4">
          <p>
            Standard Chartered Bank in Singapore is part of a leading
            international banking group, with a presence in 59 of the
            world&apos;s most dynamic markets for more than 160 years and
            serving clients in a further 83. Our purpose is to drive commerce
            and prosperity through our unique diversity, and our heritage and
            values are expressed in our brand promise, here for good.
          </p>

          <p>
            The Bank has a history of 163 years in Singapore, where we opened
            our first branch in 1859. In October 1999, we were among the first
            international banks to receive a Qualifying Full Bank (QFB) licence,
            an endorsement of the Group&apos;s long-standing commitment to our
            business in the country.
          </p>

          <p>
            Singapore is home to the majority of our global business leadership,
            our technology operations, as well as SC Ventures, our innovation
            hub. In 2013, the Bank transferred our Singapore Retail and SME
            businesses to a locally-incorporated subsidiary, Standard Chartered
            Bank (Singapore) Limited (&quot;SCBSL&quot;). And in May 2019, we
            fully consolidated our business operations in Singapore through the
            transfer of our Commercial Banking, Corporate & Institutional
            Banking and Private Banking businesses to SCBSL. SCBSL is one of the
            highest-rated banks globally: A1/Stable by Moody&apos;s Investor
            Services, A/Stable by Standard & Poor&apos;s and A/Stable by Fitch
            Ratings. In August 2020, we were the first and only bank to be
            awarded the “Significantly Rooted Foreign Bank” (SRFB) status by the
            Monetary Authority of Singapore. In December 2020, we were granted
            enhanced SRFB privileges, in recognition of the significantly higher
            degree of rootedness exceeding the SRFB baseline criteria.
          </p>

          <p>
            In Singapore, we support both individual and corporate needs to
            build wealth and drive commerce at every step of their journey. We
            do this by offering an entire range of financial services across
            personal, priority and private banking as well as our business, and
            corporate, commercial & institutional banking teams. The Bank has a
            network of 13 branches, including 4 Priority Banking centres, 1
            International Banking and Priority Private Centre and 23 ATMs.
          </p>

          <p>
            For more information please visit&nbsp;
            <a
              className="text-blue-175 hover:text-gray-750"
              href={STANDARD_CHARTERED_URL}
              target="_blank"
              rel="noreferrer"
            >
              www.sc.com/sg
            </a>
            .
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default StandardCharteredSection;
